import React from "react";
import { CardData } from "@/components/layout/element-layout/grid-layout/GridLayout";
import { ObjectItem, deleteObject } from "@/lib/stores/objectsStore";
import GlossaryWidget from "@/components/cards/widgets/ObjectsWidget";
import { GlossaryWizard } from "@/components/wizards/glossary/ObjectWizard";
import { ItemTypeConfig } from "./types";
import { objectsDataSource } from "@/lib/dataSources/sources/objects";

export const libraryConfig: ItemTypeConfig = {
  type: "library",
  title: "Library Objects",
  pageSection: "glossary",
  eventName: "addGlossaryItem",
  emptyStateTitle: "No Library Objects",
  emptyStateDescription:
    "No library objects found for this game. Create your first library object to get started.",
  noGameSelectedDescription:
    "Please select a game to view its library objects.",

  /**
   * Transform raw items to CardData using the DataSource transformer
   * This delegates to objectsDataSource.transformers.toCard() for single source of truth
   */
  transformData: (
    items: ObjectItem[],
    tags: any[],
    getUserNameById: (id: string) => string,
    glossaryBlueprints?: any[]
  ): CardData[] => {
    if (!items || !Array.isArray(items)) {
      console.warn("transformData: items is not an array:", items);
      return [];
    }
    
    // Use DataSource transformer with context
    const cards = objectsDataSource.transformers.toCard?.(items, {
      tags,
      blueprints: glossaryBlueprints || [],
      getUserNameById,
    }) || [];
    return cards;
  },

  renderCard: (card: CardData, tags: any[]) => {
    return (
      <GlossaryWidget
        id={card.id}
        gameId={card.gameId}
        title={card.title}
        owner={card.owner}
        tags={card.tags}
        description={card.description}
        lastUpdate={card.lastUpdate}
        version={card.version}
        status={card.status}
        folder={card.folder as string}
        itemType="library"
        icon={card.icon}
        iconBg={card.iconBg}
        shadowType={card.shadowType}
        shadowColor={card.shadowColor}
        hasVersionMismatch={card.hasVersionMismatch}
        onDelete={card.onDelete}
        onEdit={card.onEdit}
      />
    );
  },

  getWizard: (props: any) => {
    return <GlossaryWizard {...props} onSave={props.onSave} onUpdate={props.onUpdate} />;
  },

  handleDelete: async (id: string, gameId: string, toast: any) => {
    await deleteObject(id, gameId, toast);
  },

  handleCardClick: (card: CardData) => {
    // Navigation handled by hook
  },

  handleAdd: () => {
    // Handled by hook
  },
};

